<template>
  <tr v-if="amount > 0">
    <td>
      <div v-if="unitIsSqm"> {{ displayName }} {{ amount }}m<sup>2</sup></div>
      <div v-if="unitIsPc">{{ amount }}x {{ displayName }}</div>
      <small v-if="unitIsPc && article.inclusive > 0">
        ({{ article.inclusive }} incl.)
      </small>
      <small v-if="unitIsSqm && article.inclusive > 0">
        ({{ article.inclusive }} /m<sup>2</sup> incl.)
      </small>
    </td>
    <td class="text-right width--25">{{ $filters.formatMoney(totalNet) }}</td>
  </tr>		
</template>

<script setup>
import { UNIT_PC, UNIT_SQM } from '@/constants'
import { useMainStore } from '@/store'
import { addLateDeliverySurcharge } from '@/utils/helper'
import { computed } from 'vue'

const store = useMainStore()
// define passed props
const props = defineProps({
  article: {
    type: Object,
    required: true
  }
})
// define computed props
const locale = computed(() => store.settings.locale)
const basket = computed(() => store.print.basket)
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)
const lateDelivery = computed(() => store.tmp.late_delivery)

const baseArticle = computed(() => {
  return props.article.article
})

const displayName = computed(() => {
  if (props.article.booth_refinement_id) {
    return (locale.value === 'en') ? props.article.name_en : props.article.name  
  }
  return (locale.value === 'en') ? baseArticle.value.name_en : baseArticle.value.name
})

const squareMeter = computed(() => {
  return basket.value.width * basket.value.depth
})

const amount = computed(() => {
  if (props.article.inclusive_unit === UNIT_SQM) {
    return Math.floor(squareMeter.value * props.article.count)
  }

  return props.article.count
})

const correctedAmount = computed(() => {
  return amount.value - ((props.article.inclusive) ? props.article.inclusive : 0)
})

const unitIsPc = computed(() => {
  return props.article.unit === UNIT_PC
})

const unitIsSqm = computed(() => {
  return props.article.unit === UNIT_SQM
})

const totalNet = computed(() => {
  const netPrice = (earlyBirdMode.value)
    ? addLateDeliverySurcharge(props.article.exhibition_prices.price_net, lateDelivery.value)
    : props.article.exhibition_prices.price_net
    
  return correctedAmount.value * netPrice
})
</script>